<template>
	<b-container class="show-document">
		<div class="doc-body" style="text-align: center; align-items: center">
			<div class="actions mb-2 mt-2 hidden-print">
				<div class="pull-left">
					<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
				</div>
				<div class="pull-right">
					<b-button variant="outline-dark" class="mr-2" @click="print">
						<i class="fa fa-print"></i> Печать {{ $t('incomes.create.prices') }}
					</b-button>
					<div class="clearfix"></div>
				</div>
				<div class="clearfix"></div>
			</div>
			<div>
				<div class="printElement text-center mt-4" v-for="n in count">
					<p class="text-center specialBarcode"><b>{{item.barcode}}</b><br/></p>
					<p class="text-center info">{{ item.itemName }}</p><br/>
					<b class="price" style="font-size: 40px">$ {{ item.priceUzs * (item.ratio ? item.ratio : 1) }}<br></b>
					<barcode :value="item.multiBarcode" :options="{ height: '30px',displayValue: false}" tag="svg"></barcode>
					<p style="font-size: 16px" class="barcode"><b>{{ item.multiBarcode }}</b></p>
				</div>
			</div>
		</div>
	</b-container>
</template>

<script>
import PricesService from "../../../../services/prices.service";

export default {
	name: "PriceGenerate",
	data() {
		return {
			item: {},
			count: 0
		}
	},
	methods: {
		get() {
			let barcode = this.$route.params.barcode,
				depId = this.$route.params.depId,
				itemId = this.$route.params.itemId;
			this.count = parseInt(this.$route.params.count);
			let link = '?barcode=' + barcode + '&itemId=' + itemId;
			if (depId != 'null')
				link+=`&depId=${depId}`
			PricesService.getItemByPrice(link).then(res => {
				this.item = res.data
			})
		},
		goBackToFrom() {
			this.$router.back();
		},
		async removePageSizeStyle() {
			var el = document.getElementById('stylePrintSizeId');
			if (el) {
				el.remove(); // Removes the div with the 'stylePrintSizeId' id
			}
		},
		async setPageSizeStyle(sizeValue) {
			var css = `@page { size: ${sizeValue}; }`,
				head = document.head || document.getElementsByTagName('head')[0],
				style = document.createElement('style');

			style.type = 'text/css';
			style.media = 'print';
			style.id = 'stylePrintSizeId';

			if (style.styleSheet){
				style.styleSheet.cssText = css;
			} else {
				style.appendChild(document.createTextNode(css));
			}

			head.appendChild(style);
		},
		async print() {
			await this.removePageSizeStyle();
			await this.setPageSizeStyle('landscape');
			window.print();
		}
	},
	async created() {
		await this.get();
	}
}
</script>

<style scoped>
body {
	background-color: white !important;
}
@page {
	margin: 0 !important;
}
p {
	margin-bottom: 0px;
	font-size: 15px;
}
@media print {
	html, body {
		margin: 0 !important;
		text-align: center;
		padding: 0 !important;
	}
	/* @page { size: landscape; } */
	.hidden-print {
		display: none;
	}
	.printElement {
		margin-top: 10px !important;
		margin-bottom: 0 !important;
		margin-left: 10px !important;
		text-align: center;
		page-break-after: always;
		word-break: break-all;
		line-height: 120%;
		color: #000;
		width: 80mm !important;
		height: 40mm !important;
	}
	.printElement p {
		width: 100%;
		font-family: "Arial Black", Gadget, sans-serif;
		text-align: center;
		color: #000000 !important;
		font-weight: bold;
		page-break-inside: avoid;
	}
	.info {
		font-size: 14px !important;
	}
	.specialBarcode {
		font-size: 15px;
		margin-left: 30%;
	}
	.card {
		box-shadow: none;
	}
	svg {
		width: 100% !important;
		position: relative;
		bottom: 0;
		left: 0;
	}
	.price {
		margin-top: -5px !important;
		font-size: 60px !important;
	}
	.barcode {
		position: relative;
		font-size: 13px;
		margin-top: -8px;
	}
}
</style>
